angular.module('localytics.factory', [
    // Global localytics factory
])
    .service('LL', [function () {
        // TODO: REMOVE THIS WHEN WE REENABLE LOCALYTICS!!!
        this.localyticsEnabled = false;


        this.tagEvent = (eventName, eventObj) => {
            if (!this.localyticsEnabled) return;
            if (!ll) return;
            ll('tagEvent', eventName, eventObj);
        };

        this.setCustomerData = (customerId, customerName, customerEmail) => {
            if (!this.localyticsEnabled) return;
            if (!ll) return;
            ll('setCustomerId', customerId);
            ll('setCustomerName', customerName);
            ll('setCustomerEmail', customerEmail);
        }

        this.setCustomDimension = (dimensionKey, dimensionValue) => {
            if (!this.localyticsEnabled) return;
            if (!ll) return;
            ll('setCustomDimension', dimensionKey, dimensionValue);
        };

        this.tagHoldSelectEvent = () => {
            this.tagEvent("Hold Select");
        };

        this.tagChangeOrCancelSelectEvent = () => {
            this.tagEvent("Change or Cancel Select");
        };

        this.tagCancelSelectEvent = (responseObj, isTrial, currentPlanName, trialOfferName) => {
            var llObject = {
                "Trial": isTrial,
                "Current PlanName": currentPlanName,
                "Trial Offer Name": trialOfferName
            };

            this.tagEvent("Cancel Select", llObject);
        };

        this.tagCancelEvent = (responseObj, isTrial, currentPlanName, planCycle) => {
            var llObject = null;
            llObject = {
                "Trial": isTrial,
                "Current PlanName": currentPlanName,
                "Plan Cycle": planCycle
            };

            if ((responseObj.responseText == "SUCCESS")) {
                llObject.success = "yes";
            } else {
                llObject.success = "no";
            }
            this.tagEvent("Cancel", llObject);
        };

        this.tagXtraCreditPurchaseEvent = (price, responseObj) => {
            var llObject = null;
            if ((responseObj.responseText == "SUCCESS")) {
                llObject = {
                    "Price": price,
                    "Success": "yes"
                }
            } else {
                llObject = {
                    "Price": price,
                    "Success": "no"
                }
            }
            this.tagEvent("eXtra Credit Purchase", llObject);
        };

        this.tagTrialPurchase = (paymentDetails) => {
            var llObject = null;

            llObject = {
                "Trial Plan": paymentDetails.trialPlan == '' ? 'None' : paymentDetails.trialPlan,
                "Trial Period": paymentDetails.trialPeriod,
                "Plan Selected": paymentDetails.planSelected == '' ? 'None' : paymentDetails.planSelected,
                "Plan Period": paymentDetails.planPeriod,
                "Opt In Marketing": paymentDetails.optInMarketing ? 'yes' : 'no',
                "Payment Type": paymentDetails.paymentType ? "PayPal" : "Credit Card",
                "Success": paymentDetails.succcess ? "yes" : "no",
                "OfferName": paymentDetails.trialPlan == '' ? 'None' : paymentDetails.trialPlan,
                "Source": paymentDetails.source ? paymentDetails.source : "None"
            };
            this.tagEvent("Trial Purchase", llObject);
        };

        this.tagSubscriptionPurchase = (plan,
                                        subscriptionRenewalDate,
                                        nextBillingAttemptDate,
                                        subscriptionName,
                                        paymentType,
                                        response,
                                        offerName,
                                        offerPeriod,
                                        offerType,
                                        offerPrice,
                                        source) => {
            var llObject = {
                "Plan Name": plan.description,
                "Plan Period": plan.billingCycleUnitType,
                "Price": offerPrice,
                "Payment Type": paymentType,
                "Next Credit Refresh Date": subscriptionRenewalDate,
                "Next Bill Refresh Date": nextBillingAttemptDate,
                "Offer Name": (offerName != null) ? offerName : 'None',
                "Offer Period": (offerPeriod != null) ? offerPeriod : 'None',
                "Offer Type": (offerType != null) ? offerType : 'None',
                "Offer End Date": 'None',
                "Source": (source != null) ? source : 'None',
                "Success": response.responseText == "SUCCESS" ? "yes" : "no"
            };
            this.tagEvent('Subscription Purchase', llObject);
        }
        ;

        this.tagChangePlan = (typeOfChange,
                              oldPlanName,
                              newPlanName,
                              isCancelSave) => {
            var llObject = {
                "Type": typeOfChange,
                "Old Plan Name": oldPlanName,
                "New Plan Name": newPlanName,
                "isCancelSave": isCancelSave
            };

            this.tagEvent('Change Plan', llObject);
        }
        ;

        this.tagBrowsedGenreLlEvent = (genreName) => {
            var llObject = {
                "Genre Name": genreName
            };
            this.tagEvent('Browsed Genre', llObject);
        };

        this.tagSaveBookmark = (bookmarkObj, type, llObject) => {
            llObject["Type"] = type;
            llObject["Content"] = bookmarkObj.note == null ? "No" : "Yes";
            llObject["Content Typed"] = bookmarkObj.note;
            this.tagEvent('Bookmark', llObject);

        };

        this.tagSearchCatalogEvent = (textSearched,
                                      authorCount,
                                      narratorCount,
                                      publisherCount,
                                      titleCount,
                                      inPanel,
                                      arrayOfSearchResultBookIds) => {
            var eventName = inPanel ? 'Searched Catalog Panel' : 'Searched Catalog';

            var llObject = {
                "Text Searched": textSearched,
                "Count of Results for Author": authorCount,
                "Count of Results for Narrator": narratorCount,
                "Count of Results for Title": titleCount,
                "Count of Results for Publisher": publisherCount
            };

            this.tagEvent(eventName, llObject);
            fbq('track', 'Search',
                {
                    search_string: textSearched,
                    content_ids: arrayOfSearchResultBookIds,
                    content_type: 'product_group'
                });
        }
        ;

        this.convertAudiobookToLocalyticsObject = (audiobook) => {
            if (audiobook == null) {
                return null;
            }

            var result = {
                "Title": audiobook.title,
                "Book ID": audiobook.id,
                "Duration": audiobook.runtime,
                "DRM free": audiobook.drmFree
            };

            if (audiobook.series != null && audiobook.series.name != null) {
                result.Series = audiobook.series.name;
            }

            for (var i = 0; i < audiobook.genreList.length; i++) {
                var genre = audiobook.genreList[i];
                if (!result["Genre"]) {
                    result["Genre"] = [];
                }
                result["Genre"].push(genre.name);
            }

            for (i = 0; i < audiobook.authorList.length; i++) {
                var author = audiobook.authorList[i];
                if (!result["Author"]) {
                    result["Author"] = [];
                }
                result["Author"].push(author.name);
            }

            for (i = 0; i < audiobook.narratorList.length; i++) {
                var narrator = audiobook.narratorList[i];
                if (!result["Narrator"]) {
                    result["Narrator"] = [];
                }
                result["Narrator"].push(narrator.name);
            }

            return result;
        };

        /*Search Select Events*/

        this.tagSearchSelectAuthorLlEvent = (authorName, inPanel) => {
            var eventName = inPanel ? 'Search Select Panel' : 'Search Select';
            this.tagEvent(eventName, {'Author': authorName})
        };

        this.tagSearchSelectNarratorLlEvent = (narratorName, inPanel) => {
            var eventName = inPanel ? 'Search Select Panel' : 'Search Select';
            this.tagEvent(eventName, {'Narrator': narratorName});
        };

        this.tagSearchSelectPublisherLlEvent = (publisherName, inPanel) => {
            var eventName = inPanel ? 'Search Select Panel' : 'Search Select';
            this.tagEvent(eventName, {'Publiser': publisherName});
        };

        this.tagSearchSelectTitleLlEvent = (bookTitle, inPanel) => {
            var eventName = inPanel ? 'Search Select Panel' : 'Search Select';
            this.tagEvent(eventName, {'Title': bookTitle});
        }
    }
    ]);

